module.exports = __webpack_public_path__ + "img/image_logo.055e9b72.png";